import i18n from 'i18next';
import { LS_DEBUG_LANGUAGE_KEY, LS_LANGUAGE_KEY } from '../config';
import { isLanguageSupported } from './isLanguageSupported';

const isDebugMode = localStorage.getItem(LS_DEBUG_LANGUAGE_KEY);

/** Используется для одновременного обновления выбранного языка
 * в i18n и в localStorage. Также учитывает проверки на поддерживаемость языка
 * Используйте только эту функцию, в компонентах смены языка! Не обновляйте
 * localstorage или i18n по отдельности!
 */
export const changeLanguage = (language?: string, doNotSaveToLS?: boolean): string | undefined => {
  if (!language) return;
  if (!isLanguageSupported(language)) return;
  i18n.changeLanguage(language);

  if (!doNotSaveToLS) {
    if (isDebugMode) {
      console.debug('записали язык в localstorage');
    }
    localStorage.setItem(LS_LANGUAGE_KEY, language);
  }
  return language;
};
